import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../translation/en.json";
import ar from "../translation/ar.json";
import { setLanguageKey } from "./session";

const savedLang = sessionStorage.getItem("appLanguage") || "ar";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar }
  },
  lng: savedLang,
  fallbackLng: "en",
  interpolation: { escapeValue: false }
});

document.documentElement.dir = savedLang === "ar" ? "rtl" : "ltr";
document.documentElement.lang = savedLang;

i18n.on("languageChanged", (lng) => {
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lng;

  setLanguageKey(lng)
});

export default i18n;
